import { FeaturesDisplayLayoutUI } from './FeaturesDisplayLayoutUI';
import { PriorityFeatures } from './PriorityFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UncategorizedPriorityFeatures = ({
  uncategorizedFeatures,
  isCollapsible = false,
  lowerTierMessage,
  renderFeatureName,
  onFeatureHover,
  agentFeatures
}) => {
  const FeaturesListSection = /*#__PURE__*/_jsxs(_Fragment, {
    children: [agentFeatures, /*#__PURE__*/_jsx(PriorityFeatures, {
      features: uncategorizedFeatures,
      renderFeatureName: renderFeatureName,
      onFeatureHover: onFeatureHover
    })]
  });
  return /*#__PURE__*/_jsx(FeaturesDisplayLayoutUI, {
    HeaderSection: lowerTierMessage || undefined,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};